import { service } from '@ember/service';
import Route from '@ember/routing/route';

// This route will be used to verify the payment link token, store the session
// and display the DOB verification page (BILL-1175)
// As for now, we will just display the session data and the DOB verification page later.
export default class PaymentLinkVerifyRoute extends Route {
  @service router;
  @service fastboot;
  @service currentPractice;
  @service store;
  @service signIn;

  beforeModel() {
    if (this.fastboot.isFastBoot) {
      return;
    }

    if (!this._areFeatureFlagsEnabled()) {
      return this.router.transitionTo('not-found', 'errors/404');
    }

    if (!this._getUrlToken()) {
      return this.router.transitionTo('not-found', 'errors/404');
    }
  }

  model() {
    if (this.fastboot.isFastBoot) {
      return;
    }

    return this.store.createRecord('payment-link-session', {
      token: this._getUrlToken(),
    });
  }

  async setupController(_controller, model) {
    super.setupController(...arguments);

    if (this.fastboot.isFastBoot) {
      return;
    }

    await this.authenticateSession(model);
  }

  async authenticateSession(model) {
    let success = await this.signIn.verifyTokenTask.perform(model);
    if (success) {
      return this.router.transitionTo('payment-link.show');
    }

    this.router.transitionTo('payment-link.expired');
  }

  _areFeatureFlagsEnabled() {
    return (
      this.currentPractice.get('featurePaymentLinksSms') &&
      this.currentPractice.get('featurePaymentLinks')
    );
  }
  _getUrlToken() {
    return location.hash && location.hash.length > 1 ? location.hash.substring(1) : null;
  }
}
